const SubmitButton = function () {
  return {
    setDisabled: null,
    setEnabled: null,
    reset: null
  }
}

export default SubmitButton
